export default function scrollTop() {
  window.scrollTo(0, 0);
}
